import React from 'react'

const Sponsored = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__sponsored ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 78 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <rect fill='#9B9B9B' width='78' height='21' />
    <polygon fill='#4A4A4A' points='0,21 6,21 6,25' />
    <text
      style={{ textTransform: 'uppercase', letterSpacing: '0.7px' }}
      x='9'
      y='15'
      fontFamily='ArgosCondensed,Arial,Helvetica,sans-serif'
      fontSize='14'
      fill='white'>
      Sponsored
    </text>
  </svg>
)

export default Sponsored
